module.exports = __webpack_public_path__ + "img/csm_expovina_05_web_696321b23f.0937ef95.jpg";